import BaseModel from './base';

export default class UserDuplicateMemberEvent extends BaseModel {
  constructor(userDuplicateMemberEvent) {
    super(userDuplicateMemberEvent);

    this.id = userDuplicateMemberEvent.id;
    this.name = userDuplicateMemberEvent.name;
    this.short_name = userDuplicateMemberEvent.short_name;
    this.prize_places = userDuplicateMemberEvent.prize_places; // { place: number; nomination_id: number }[] | null;
  }
}
